<paper-input id="search-bar" name="search-bar" label="{{'Search cases'|translate}}" #searchBar></paper-input>
<paper-checkbox #viewArchived class="view-archived">{{'View Archived Cases'|translate}}</paper-checkbox>
<div id="search-results" #searchResults>
</div>
  